import { ga } from 'js/analytics/adapters'
export const trackReadMoreInHero = () => {
  ga.track('Click on "Read more" in hero')
}
